import React, { forwardRef } from 'react';
import { format } from 'date-fns';
import { Field } from '@/Framework/UI/Organisms/FinalForm';
import DatePicker from '@dealroadshow/uikit/core/components/Picker/DatePicker';
import IconCalendar from '@dealroadshow/uikit/core/components/Icon/IconCalendar';
import Input from '@dealroadshow/uikit/core/components/Input';
import { YEAR_MONTH_DAY_SLASH_FORMAT } from '@/Framework/DateTime/dateFormats';
import { PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY } from './constants';
import { IFinalFormFieldInputComponentProps } from '@/Framework/UI/Organisms/FinalForm/interfaces';

import styles from './styles.scss';

interface IProps {
  cellName: string,
  rowIndex: number,
}

const CustomInput = forwardRef((
  {
    meta,
    dataTest,
    ...inputProps
  }: { meta: IFinalFormFieldInputComponentProps['meta'], dataTest: string },
  ref: React.ForwardedRef<Input>,
) => (
  <Input
    // @ts-ignore
    input={ { ref, ...inputProps } }
    meta={ meta }
    iconPosition="right"
    isClearable={ false }
    isNarrow
    icon={ IconCalendar }
    dataTest={ dataTest }
    formFieldClassName={ styles.datePickerInput }
  />
));

const DatePurchasedCell = (props: IProps) => {
  const {
    cellName,
    rowIndex,
  } = props;

  return (
    <Field
      name={ `${ PORTFOLIO_OPTIONAL_DATA_FIELD_ARRAY }[${ rowIndex }].${ cellName }` }
    >
      { ({
        meta,
        input,
      }) => (
        <DatePicker
          customInput={ <CustomInput meta={ meta } dataTest={ cellName } /> }
          maxDate={ new Date() }
          selected={ input.value ? new Date(input.value) : null }
          onChange={ (value: Date) => input.onChange(format(value, YEAR_MONTH_DAY_SLASH_FORMAT)) }
          dateFormat={ YEAR_MONTH_DAY_SLASH_FORMAT }
          placeholderText="Select Date"
          popperPlacement="bottom-end"
          dataTest="datepicker"
        />
      ) }
    </Field>
  );
};

export default DatePurchasedCell;
